export default __webpack_public_path__ + "static/media/email.0161ffc3.svg";